<template>
  <div :class="['section-right-content-box', {'isList': showTab}]">
    <div class="page-column-name" v-if="showTab">{{ $route.meta.title }}</div>
    <div v-if="showTab">
      <!-- <myTab :tabInfo="tabInfo" :isDefaultIndex="true" :defaultIndex="activeName" @switch="handleClick" v-if="showTab"></myTab> -->
      <jdTab
        :tabsList="tabInfo"
        :fatherTabAct="activeName"
        @input="handleClick" />
    </div>
    <!-- <div class="box-shadow" v-if="showTab">
      <div class="container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="互动玩法" name="activity"></el-tab-pane>
          <el-tab-pane label="积分兑换" name="credits"></el-tab-pane>
          <el-tab-pane label="礼包弹窗" name="gift"></el-tab-pane>
          <el-tab-pane label="小部件" name="widget"></el-tab-pane>
          <el-tab-pane label="促销方式" name="promotion"></el-tab-pane>
        </el-tabs>
      </div>
    </div> -->
    <div
      class="box-shadow"
      :class="{
        'height-shadow': showTab,
        'height-shadow-none':!showTab,
      }"
      :style="{
        borderRadius: showTab ? '0px 0px 0px 0px' : '16px 16px 0px 0px',
      }">
      <template v-if="activeName == 'activity'">
        <!-- <interactList :mainTypes="1" @tabChange="showTabFn"></interactList> -->
        <pointAuctionDecoration :mainTypes="1" @changeTab="activeName = 'credits'"></pointAuctionDecoration>
      </template>

      <!-- 积分竞拍 -->
      <template v-if="activeName == 'credits'">
        <point @tabChange="showTabFn"></point>
      </template>
      <!-- 成交记录 -->
      <template v-if="activeName == 'dealRecord'">
        <dealRecord :isShowPageTitle="false" :activityType="70"></dealRecord>
      </template>
      <!-- 领奖记录 -->
      <template v-if="activeName == 'awardRecord'">
        <awardRecord :isShowPageTitle="false" :activityType="70" ></awardRecord>
      </template>
      <template v-if="activeName == 'prizes'">
        <giftList :isShowPageTitle="false" :activityType="70"></giftList>
      </template>
    </div>
  </div>
</template>
<script>
import point from "./pointAuction/ponitActive.vue";
import pointAuctionDecoration from "./components/pointAuction/pointAuctionDecoration.vue";
import dealRecord from "./pointAuction/components/dealRecord.vue";
import awardRecord from "./pointAuction/components/awardRecord.vue";



import interactList from "./list/interactList.vue";
import giftList from "@/views/interactiveMarketing/gift_list/index.vue";
import widgetList from "./cardManage/scratchers.vue";
import iouList from "./iou/index.vue";
import myTab from "@/components/myTab.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "activityManagement",

  components: {
    interactList,
    giftList,
    widgetList,
    iouList,
    myTab,
    point,
    pointAuctionDecoration,
    dealRecord,
    awardRecord,
  },

  filters: {},

  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),

    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },

  data() {
    return {
      activeName: "activity",
      showTab: true,
      tabInfo: [
        { title: "积分竞拍列表装修", tabKey: "activity" },
        { title: "积分竞拍活动", tabKey: "credits" },
        { title: "成交记录", tabKey: "dealRecord" },
        { title: "领奖记录", tabKey: "awardRecord" },
        { title: "实物奖品名单", tabKey: "prizes" },
      ],
    };
  },

  mounted: function () {
       this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
  },

  created() {
    // 埋点

    // 互动广场携带参数跳转
    if (this.$route.query.sort) {
      this.activeName = this.$route.query.sort;
      console.log("this.activeName------>", this.activeName);
    }
  },

  methods: {
    handleClick(val) {
      if (this.$route.query.activityType) {
        this.$router.push({ query: {} });
      }
      if (val == "activity") {
        this.activeName = "";
        setTimeout(() => {
          this.activeName = "activity";
        }, 1);
      } else if (val == "gift") {
        this.activeName = "";
        setTimeout(() => {
          this.activeName = "gift";
        }, 1);
      } else {
        this.activeName = val;
      }
    },

    showTabFn(val) {
      this.showTab = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  .box-shadow {
    overflow: auto;
  }
  // .top-select {
  //   background: #ffffff;
  //   border-radius: 16px 16px 0 0;
  //   padding: 0 20px;
  //   height: 42px;
  //   line-height: 42px;
  // }

  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #f6f6f6;
    z-index: 1;
  }
}

.isList {
  padding: 16px;
}
.height-shadow-none{
  height: 100%;
}
.height-shadow{
  height: calc(100% - 95px);
}
</style>
